export const icons24 = [
  "add-layer",
  "add",
  "align-center",
  "align-left",
  "align-right",
  "analytics-accent",
  "analytics",
  "annotate",
  "annotation",
  "area",
  "arrow-down",
  "arrow-left-curved",
  "arrow-left",
  "arrow-link",
  "arrow-right",
  "arrow-up",
  "axes",
  "bar-cross",
  "bar-error",
  "bar-stacked",
  "bar-trend",
  "bar",
  "bindot",
  "box",
  "boxplot-binned",
  "boxplot-jitter",
  "boxplot-notched",
  "boxplot",
  "bubble",
  "calendar",
  "canvas",
  "cell-type-num",
  "cell-type-subset",
  "cell-type-txt",
  "checkbox-checked",
  "checkbox-intermediate",
  "checkbox",
  "checkmark",
  "chevron-down",
  "chevron-first",
  "chevron-last",
  "chevron-left",
  "chevron-right",
  "chevron-sort",
  "chevron-up",
  "clipboard-copied",
  "clipboard",
  "close",
  "cloud-download",
  "cloud-offline",
  "cloud-online",
  "cloud-upload",
  "cluster",
  "code",
  "color-fill",
  "color-none",
  "color-stroke",
  "color",
  "columns",
  "connected-points",
  "container",
  "cookie",
  "copy",
  "cpu",
  "cursor-pointer",
  "data-dimentions",
  "debug",
  "delete-bin",
  "delete-circle",
  "delete-clear",
  "dendrogram-X-line",
  "dendrogram-X",
  "dendrogram-Y-line",
  "dendrogram-Y",
  "dna-add",
  "dna-import",
  "dna",
  "download",
  "drag-dots",
  "drag-horizontal",
  "drag-vertical",
  "duplicate",
  "edit",
  "error-bar",
  "error",
  "expand-left",
  "expand-right",
  "export",
  "file-doc-add",
  "file-doc-download",
  "file-doc-import",
  "file-doc",
  "file-logs-accent",
  "file-logs",
  "filter-on",
  "filter",
  "fire-tips",
  "folder-parent",
  "frame-type-all",
  "frame-type-bottom",
  "frame-type-left-bottom",
  "frame-type-left",
  "frame-type-none",
  "generate",
  "graph",
  "heatmap",
  "help-outline",
  "help",
  "info-outline",
  "info",
  "jitter",
  "jump-link",
  "lasso",
  "layers",
  "learn",
  "legend-box-dot",
  "legend-box",
  "legend",
  "line-binned",
  "line-error",
  "line-jitter",
  "line",
  "linetype-dashed",
  "linetype-dotdash",
  "linetype-dotted",
  "linetype-longdash",
  "linetype-solid",
  "linetype-twodash",
  "link-disabled",
  "link",
  "loading",
  "lock",
  "maximize",
  "menu",
  "minimize",
  "minus",
  "monetization-off",
  "monetization-on",
  "monetization",
  "more",
  "paper-clip",
  "pause",
  "pen-tool",
  "pin",
  "play",
  "position-bottom-annotation",
  "position-bottom",
  "position-left-annotation",
  "position-left",
  "position-right-annotation",
  "position-right",
  "position-top-annotation",
  "position-top",
  "product",
  "progress",
  "publications",
  "radio-button-checked",
  "radio-button",
  "renew",
  "restart",
  "reverse",
  "rotation-0",
  "rotation-45",
  "rotation-90",
  "search",
  "server-on",
  "server",
  "settings",
  "sina",
  "skatterplot",
  "slice",
  "social-github",
  "social-linkedin",
  "social-twitter-X",
  "social-twitter-bird",
  "social-youtube",
  "sort-list-down",
  "sort-list-up",
  "sort",
  "statistics",
  "stop",
  "strip-plot",
  "success",
  "table-add",
  "table-alias",
  "table-import",
  "table",
  "template",
  "terminal",
  "text-align-center",
  "text-align-left",
  "text-align-right",
  "theme-dark",
  "theme-light",
  "time",
  "tune",
  "venn",
  "view-hide",
  "view-show",
  "violin-binned",
  "violin-jitter",
  "violin",
  "warning",
  "wetlab",
  "windows-collapse",
  "windows-expand",
  "x-axis",
  "y-axis",
  "zip",
  "zoom-in",
  "zoom-out",
] as const;
